var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useStoreActions } from 'common/store/use-store-actions';
import { useChatMembersStore } from './service-store/service-store';
import { addChatMembersApi, leaveChatApi, removeChatMembersApi } from './api';
import { chatMembersQueryKeys, chatsListQueryKeys } from '../api-tags';
export var useChatMembersActions = function () {
    var actions = useStoreActions(useChatMembersStore);
    var queryClient = useQueryClient();
    return useMemo(function () { return (__assign(__assign({}, actions), { invalidateChatMembersAction: function (chatId) {
            return queryClient.invalidateQueries({
                queryKey: chatId ? chatMembersQueryKeys.byId(chatId) : chatMembersQueryKeys.all,
            });
        }, leaveChatAction: function (_a) {
            var chatId = _a.chatId, successCb = _a.successCb, errorCb = _a.errorCb;
            return leaveChatApi({ chatId: chatId })
                .then(function () {
                successCb === null || successCb === void 0 ? void 0 : successCb();
                queryClient.invalidateQueries({
                    queryKey: chatMembersQueryKeys.byId(chatId),
                    refetchType: 'none',
                });
                queryClient.invalidateQueries({ queryKey: chatsListQueryKeys.all });
            })
                .catch(function (error) {
                console.log('leaveChatAction ->', error);
                errorCb === null || errorCb === void 0 ? void 0 : errorCb();
            });
        }, addChatMembersAction: function (_a) {
            var successCb = _a.successCb, errorCb = _a.errorCb, params = __rest(_a, ["successCb", "errorCb"]);
            var chatId = params.chatId;
            return addChatMembersApi(params)
                .then(function () {
                if (useChatMembersStore.getState().chatId === chatId)
                    actions.resetPageContent();
                queryClient.invalidateQueries({
                    queryKey: chatMembersQueryKeys.byId(chatId),
                });
                queryClient.invalidateQueries({
                    queryKey: chatsListQueryKeys.all,
                });
                successCb === null || successCb === void 0 ? void 0 : successCb();
            })
                .catch(function (error) {
                console.log('addChatMembersAction ->', error);
                actions.setLoading(false);
                errorCb === null || errorCb === void 0 ? void 0 : errorCb();
            });
        }, removeChatMembersAction: function (_a) {
            var chatId = _a.chatId, members = _a.members, successCb = _a.successCb, errorCb = _a.errorCb;
            return removeChatMembersApi({ chatId: chatId, members: members })
                .then(function () {
                if (useChatMembersStore.getState().chatId === chatId)
                    actions.resetPageContent();
                queryClient.invalidateQueries({
                    queryKey: chatMembersQueryKeys.byId(chatId),
                });
                queryClient.invalidateQueries({
                    queryKey: chatsListQueryKeys.all,
                });
                successCb === null || successCb === void 0 ? void 0 : successCb();
            })
                .catch(function (error) {
                console.log('removeChatMembersAction ->', error);
                actions.setLoading(false);
                errorCb === null || errorCb === void 0 ? void 0 : errorCb();
            });
        } })); }, [actions, queryClient]);
};
